//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import constant from '~/const/index';
import tableConfig from './tableConfig';

export default {
  data() {
    return {
      constant,
      tableConfig,
      risks: [],
    };
  },

  computed: {
    ...mapState('settingsAMLKYT', ['data']),
    ...mapState('login', ['currentAdmin']),
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadData(),
    ]);
    this.setGeneralLoader(false);
  },

  watch: {
    data: {
      handler(newVal) {
        if (newVal?.length) {
          this.risks = [...constant.settings.KYT_RISKS_LIST.map((e) => {
            return ({
              id: e.id,
              value: this.getCurrentValue(e.id) || e.defaultValue,
            });
          })];
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('settingsAMLKYT', [
      'loadData',
      'editRisks',
    ]),

    getCurrentValue(key) {
      if (!this.data || this.data.length === 0) return '';
      const obj = this.data.find((e) => e.id === Number(key));
      return obj ? obj.value : '';
    },

    async save() {
      this.confirmAction({
        title: 'Are you sure, you want save this changes?',
        text: 'It will have effect on all operations',
        callback: async () => {
          this.setGeneralLoader(true);
          try {
            await this.editRisks({
              riskCategories: this.risks,
              adminId: this.currentAdmin.id,
            });
            await this.loadData();
            this.setSuccessNotification('Saved successfully');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralLoader(false);
        },
      });
    },
  },
};
